import { Signal, SignalType } from "@types";
import {
  ArrowDownIcon,
  ArrowsIcon,
  ArrowUpIcon,
  BrandIcon,
  EnvelopeIcon,
  MinusIcon,
  PlusIcon,
} from "../icons";

export const getSignalIcon = (signal?: Signal) => {
  switch (signal?.eventName) {
    case SignalType.Welcome:
    case SignalType.WelcomeBack:
    case SignalType.NewTeamMember:
      return BrandIcon;
    case SignalType.ToAdded:
    case SignalType.CcAdded:
    case SignalType.ToThirdPartyAdded:
    case SignalType.CcThirdPartyAdded:
      return PlusIcon;
    case SignalType.ToRemoved:
    case SignalType.CcRemoved:
    case SignalType.ToThirdPartyRemoved:
    case SignalType.CcThirdPartyRemoved:
      return MinusIcon;
    case SignalType.PointOfContactChanged:
      return ArrowsIcon;
    case SignalType.SentimentIncreased:
      return ArrowUpIcon;
    case SignalType.SentimentDecreased:
      return ArrowDownIcon;
    case SignalType.EmailOpened:
      return EnvelopeIcon;
    default:
      return null;
  }
};
